import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
const RootLayout = () => {
  return (
    <div className="flex h-[100svh] w-full">
      <Sidebar />
      <Outlet />
    </div>
  )
}

export default RootLayout
